import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { useContext } from 'react';
import styled from 'styled-components';
import { ColumnsContext } from "./Columns";
import { responsiveThemeStyle } from "../../theme/responsive";

var getSizeStyle = function getSizeStyle(scale) {
  return "\n  0 0 ".concat(scale * 100, "%\n");
};

export var widths = {
  '1/2': getSizeStyle(1 / 2),
  '1/3': getSizeStyle(1 / 3),
  '2/3': getSizeStyle(2 / 3),
  '1/4': getSizeStyle(1 / 4),
  '3/4': getSizeStyle(3 / 4),
  '1/5': getSizeStyle(1 / 5),
  '2/5': getSizeStyle(2 / 5),
  '3/5': getSizeStyle(3 / 5),
  '4/5': getSizeStyle(4 / 5)
};
export function Column(_ref) {
  var width = _ref.width,
      children = _ref.children,
      other = _objectWithoutProperties(_ref, ["width", "children"]);

  var gap = useContext(ColumnsContext);
  return /*#__PURE__*/React.createElement(StyledColumn, _extends({
    $width: width,
    $gap: gap
  }, other), children);
}
var responsivePadding = responsiveThemeStyle('paddingLeft', 'spaces');
var StyledColumn = styled.div.withConfig({
  displayName: "Column__StyledColumn",
  componentId: "vapor__jpjg0u-0"
})(["min-width:0;flex:", ";", ";", ""], function (p) {
  return p.$width && p.$width !== 'content' ? widths[p.$width] : null;
}, function (p) {
  return responsivePadding(p.$gap);
}, function (p) {
  if (p.$width === 'content') {
    return "\n        flex-shrink: 0;\n      ";
  }

  return "\n      height: 100%;\n      width: 100%;\n      box-sizing: border-box;\n    ";
});